module.exports = "People and businesses sending and receiving money <crud-clerk-tax-entity-curate></crud-clerk-tax-entity-curate> <crud-clerk-tax-region-curate></crud-clerk-tax-region-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/transactions.tax-entities.html
// module id = 2517
// module chunks = 86